export const LIST_AGREEMENT_PRODUCTS_SUCCESS = 'LIST_AGREEMENT_PRODUCTS_SUCCESS';
